module.exports = __webpack_public_path__ + "static/media/VU.c0987dfd.png";